import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { buscarDashboard } from '../../actions/dashboard';
import { editarBreadcrumb } from '../../actions/breadcrumb';

import DashboardAdministrador from './DashboardAdministrador';

const Dashboard = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Inicio',
            path: '/dashboard'
        }
    ];

    const dispatch = useDispatch();

    const usuario = useSelector(state => state.auth.usuario);

    useEffect(() => {
        return () => {
            dispatch(buscarDashboard(null));
        }
    }, []);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <div className="row">
            <div className="col-md-10 offset-md-1 row">
                {
                    usuario.tipo === 0 || usuario.tipo === '0' ?
                        <DashboardAdministrador />
                    :
                        null
                }
            </div>
        </div>
    )
}

export default Dashboard;